const getApiUrl = () => process.env.REACT_APP_API_URL || window.location.origin;

export default getApiUrl;
